module.exports = __webpack_public_path__ + "assets/71cce9551901cbc98d82d4e822d61c81.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/drop/11/Drop_Bonus3.mp3
 ** module id = 208
 ** module chunks = 0
 **/